import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const LegalNotice = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate(-1)}
            className="text-slate-600"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour
          </Button>
          <h1 className="text-xl font-bold text-[#101E4D]">FLOW</h1>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <article className="bg-white rounded-xl shadow-sm p-8 space-y-6">
          <div className="border-b pb-6">
            <h1 className="text-3xl font-bold text-[#101E4D] mb-2">
              Mentions Légales
            </h1>
            <p className="text-slate-500">
              Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique
            </p>
          </div>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-[#101E4D]">1. Éditeur du site</h2>
            <div className="bg-slate-50 p-4 rounded-lg text-slate-600 space-y-1">
              <p><strong>WEDO COACHING & CONSEIL</strong></p>
              <p>EURL (Entreprise Unipersonnelle à Responsabilité Limitée)</p>
              <p>Siège social : 35 Cours Pierre Puget, 13006 Marseille</p>
              <p>SIRET : 951 254 564 00010</p>
              <p>N° TVA Intracommunautaire : FR36 951 254 564</p>
              <p>Code NAF/APE : 82.99Z</p>
              <p>Email : contact@wedocoaching.com</p>
              <p>Directeur de la publication : William Marques</p>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-[#101E4D]">2. Hébergeur</h2>
            <div className="bg-slate-50 p-4 rounded-lg text-slate-600 space-y-1">
              <p><strong>Emergent Labs</strong></p>
              <p>Plateforme d'hébergement cloud</p>
              <p>Site web : emergentagent.com</p>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-[#101E4D]">3. Propriété intellectuelle</h2>
            <p className="text-slate-600 leading-relaxed">
              L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, sons, logiciels, etc.) 
              est la propriété exclusive de WEDO Coaching ou de ses partenaires et est protégé par les lois 
              françaises et internationales relatives à la propriété intellectuelle.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Toute reproduction, représentation, modification, publication, adaptation de tout ou partie 
              des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, 
              sauf autorisation écrite préalable de WEDO Coaching.
            </p>
            <p className="text-slate-600 leading-relaxed">
              WEDO Coaching utilise des modèles de personnalité reconnus dans ses accompagnements.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-[#101E4D]">4. Limitation de responsabilité</h2>
            <p className="text-slate-600 leading-relaxed">
              WEDO Coaching s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. 
              Toutefois, WEDO Coaching ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations 
              mises à disposition sur ce site.
            </p>
            <p className="text-slate-600 leading-relaxed">
              En conséquence, WEDO Coaching décline toute responsabilité :
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600 ml-4">
              <li>Pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site</li>
              <li>Pour tous dommages résultant d'une intrusion frauduleuse d'un tiers</li>
              <li>Et plus généralement, pour tous dommages, directs ou indirects, quelles qu'en soient les causes, 
                  origines, natures ou conséquences</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-[#101E4D]">5. Liens hypertextes</h2>
            <p className="text-slate-600 leading-relaxed">
              Le site peut contenir des liens hypertextes vers d'autres sites. WEDO Coaching n'exerce aucun contrôle 
              sur ces sites et décline toute responsabilité quant à leur contenu.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-[#101E4D]">6. Données personnelles</h2>
            <p className="text-slate-600 leading-relaxed">
              Pour connaître notre politique en matière de protection des données personnelles, 
              veuillez consulter notre{" "}
              <button
                onClick={() => navigate("/privacy")}
                className="text-[#FF6B35] hover:underline"
              >
                Politique de Confidentialité
              </button>.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-[#101E4D]">7. Droit applicable</h2>
            <p className="text-slate-600 leading-relaxed">
              Le présent site et ses mentions légales sont régis par le droit français. 
              En cas de litige, et après tentative de recherche d'une solution amiable, 
              les tribunaux français seront seuls compétents.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-[#101E4D]">8. Contact</h2>
            <p className="text-slate-600 leading-relaxed">
              Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter :
            </p>
            <div className="bg-slate-50 p-4 rounded-lg text-slate-600">
              <p>Email : contact@wedocoaching.com</p>
            </div>
          </section>
        </article>
      </main>
    </div>
  );
};

export default LegalNotice;
